import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  area: string;
  dirUNSAM: string;
  mail: string;

  ngOnInit() {
    this.area = 'GERENCIA DE INFORMÁTICA';
    this.dirUNSAM = 'UNSAM, Campus Miguelete, 25 de Mayo y Francia.\n' + '1650 San Martín, Buenos Aires, Argentina' ;
    this.mail = 'solicitudesti@unsam.edu.ar';
  }

}



// WEBPACK FOOTER //
// ./src/app/core/footer/footer.component.ts